import { COVERGO_SAAS_PROD } from "../consts.js"

export const exponential = {
	// CoverGo PROD
	"exponential-playground-studio.quote.hk": {
		appConfig: { tenantId: "exponential_playground", appId: "covergo_crm" },
		envConfig: COVERGO_SAAS_PROD
	}
}
